module.exports = __webpack_public_path__ + "img/comisiones.557975b4.svg";